import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
import { usePullToRefresh } from '../../shared/hooks/usePullToRefresh';
export const PullToRefresh = ({ onRefresh, children, pullThreshold = 70, resistance = 2.5, }) => {
    const theme = useTheme();
    const { isPulling, pullDistance } = usePullToRefresh({
        onRefresh,
        resistance,
        pullDownThreshold: pullThreshold,
    });
    const translateY = isPulling ? pullDistance / resistance : 0;
    const releaseToRefresh = pullDistance > pullThreshold;
    return (_jsxs(Box, Object.assign({ sx: {
            position: 'relative',
            overflowY: 'hidden',
            minHeight: '100vh',
            // Optional: Set a background color or other styles as needed
        }, "data-testid": "pull-to-refresh-container" }, { children: [_jsx(Box, Object.assign({ sx: {
                    position: 'absolute',
                    top: '56px',
                    opacity: isPulling ? 1 : 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '50px',
                    backgroundColor: releaseToRefresh
                        ? theme.palette.success.main
                        : theme.palette.info.main,
                    color: theme.palette.info.contrastText,
                    zIndex: 1000,
                    transition: 'all 0.3s ease-in-out',
                    pointerEvents: 'none',
                }, role: "status", "aria-live": "polite" }, { children: _jsx(Typography, Object.assign({ variant: "body2", fontWeight: 500 }, { children: releaseToRefresh
                        ? 'Release to refresh'
                        : 'Pull to refresh' })) })), _jsx(Box, Object.assign({ sx: {
                    transform: `translateY(${translateY}px)`,
                    transition: isPulling ? 'none' : 'transform 0.3s ease',
                    // Ensure that the content doesn't interfere with touch gestures
                    // You might want to add padding or margin to accommodate the indicator
                } }, { children: children }))] })));
};
